module.exports = "<sheet><date-range [fg]=\"fg\"></date-range><div class=\"text-center c-white animated shake\" *ngIf=\"!isValid\"><i class=\"zmdi zmdi-info-outline m-r-10\"> </i>Invalid Range</div><div class=\"layout-row layout-align-end layout-padding\"><bw-button title=\"Apply\" icon=\"check\" color=\"white\" [simple]=\"true\" (clicked)=\"onApplyClicked()\"></bw-button></div></sheet>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/date-range-sheet/date-range-sheet.component.pug
// module id = 272
// module chunks = 0